import {NgModule} from '@angular/core';
import {DatePipe, registerLocaleData} from '@angular/common';
import {HTTP_INTERCEPTORS, provideHttpClient} from '@angular/common/http';
import {Title} from '@angular/platform-browser';
import {FaIconLibrary} from '@fortawesome/angular-fontawesome';
import {CookieModule} from 'ngx-cookie';
import locale from '@angular/common/locales/da';

import moment from 'moment';
import {NgbDateAdapter, NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgbDateMomentAdapter} from '@supoui/shared/util/datepicker-adapter';

import {AuthExpiredInterceptor} from '../blocks/interceptor/auth-expired.interceptor';

import {fontAwesomeIcons} from './icons/font-awesome-icons';
import {SharedLibsModule} from '@supoui/shared/shared-libs.module';
import {provideNgxWebstorage, withNgxWebstorageConfig, withSessionStorage} from "ngx-webstorage";

@NgModule({
  imports: [
    SharedLibsModule,
    CookieModule.withOptions()
  ],
  providers: [
    provideHttpClient(),
    provideNgxWebstorage(withNgxWebstorageConfig({ prefix: 'jhi', separator: '-' }),withSessionStorage()),
    Title,
    {provide: NgbDateAdapter, useClass: NgbDateMomentAdapter},
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true
    },
  ]
})
export class CoreModule {
  constructor(iconLibrary: FaIconLibrary, dpConfig: NgbDatepickerConfig) {
    registerLocaleData(locale);
    iconLibrary.addIcons(...fontAwesomeIcons);
    dpConfig.minDate = {year: moment().year() - 100, month: 1, day: 1};
  }
}
